export default __webpack_public_path__ + "static/charRight-f9b5220bf7cecf42c40db1c655b359ef.png";